import React from 'react';
import { Alert } from 'antd';
import { getVal } from '../../../../../../shared/helpers';

const DuplicatesAlert = (props) => {
    const bikes_in_stock_is_not_sold = getVal(props, 'bike_details.ref_bike_variant.calculated_data.bikes_in_stock_is_not_sold');
    const bike_leads_with_transport_arranged = getVal(props, 'bike_details.ref_bike_variant.calculated_data.bike_leads_with_transport_arranged');


    const duplicate_max = getVal(props, 'bike_details.ref_bike_variant.duplicate_max');
    const duplicate_margin = getVal(props, 'bike_details.ref_bike_variant.duplicate_margin');
    const duplicate_stock_wanted = getVal(props, 'bike_details.ref_bike_variant.duplicate_stock_wanted');

    if (bikes_in_stock_is_not_sold || bikes_in_stock_is_not_sold === 0) {
        if (duplicate_max && (bikes_in_stock_is_not_sold === duplicate_max)) {
            return (
                <Alert
                    style={{ marginBottom: 10 }}
                    message={`We already have ${bikes_in_stock_is_not_sold} of these bikes in stock and have reached the maximum amount of bikes for this year and model`}
                    type="warning"
                    showIcon
                />
            );
        }
        if (
            (duplicate_stock_wanted || duplicate_stock_wanted === 0)
            && bikes_in_stock_is_not_sold < duplicate_max
            && bikes_in_stock_is_not_sold <= duplicate_stock_wanted
            && bikes_in_stock_is_not_sold > 0
            && bike_leads_with_transport_arranged > 0
            && duplicate_margin > 0
        ) {
            return (
                <Alert
                    style={{ marginBottom: 10 }}
                    message={`We already have ${bikes_in_stock_is_not_sold} of these bikes in stock and ${bike_leads_with_transport_arranged} in Transport Arranged, you need to use a margin of £${duplicate_margin || 0}`}
                    type="warning"
                    showIcon
                />
            );
        }
    }

    return null;
};

export default DuplicatesAlert;



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/Alerts/DuplicatesAlert.js